import { Section, sectionSpacingY } from "components/section";
import { useWarehouseCdp } from "contexts/warehouse-cdp-context";
import React from "react";
import { Accordion } from "ui/accordion";
import { TextTitle } from "ui/text";

export function WarehouseFaq() {
  const { warehouse } = useWarehouseCdp();

  const capitalizedArticle = /^[aeiou]/i.test(warehouse.name) ? "An" : "A";
  const article = capitalizedArticle.toLowerCase();

  const items = [
    {
      title: `How do you turn ${warehouse.name} into a CDP?`,
      content: `The fastest way to turn ${warehouse.name} into a CDP is to implement a Composable CDP solution like Hightouch, which gives you all the capabilities of a CDP integrated directly into your existing data infrastructure.`,
    },
    {
      title: `How does ${article} ${warehouse.name} CDP differ from traditional CDPs?`,
      content: `${capitalizedArticle} ${warehouse.name} CDP eliminates the need for separate data storage systems by letting you build and activate audiences directly within ${warehouse.name}'s environment. Unlike traditional CDPs that typically only handle user profiles and events, ${article} ${warehouse.name} CDP enables you to leverage your complete customer dataset all in one place.`,
    },
    {
      title: `Does ${article} ${warehouse.name} CDP support real-time marketing use cases?`,
      content: `${capitalizedArticle} ${warehouse.name} CDP can support real-time marketing use cases, such as cross-channel personalization, through event streaming or streaming reverse ETL.`,
    },
  ];

  return (
    <Section my={0} pb={sectionSpacingY}>
      <TextTitle align="center" size="lg" title="FAQs" />
      <Accordion items={items} maxWidth="3xl" mx="auto" mt={{ base: "big", md: "biggest" }} />
    </Section>
  );
}
